<!-- 充值 -->
<template>
    <div class="SaveMoney flex">
        <div class="SaveMoneyContentWrap">
            <div class="LoginTitle"><p><strong>Hello!</strong> 请充值...</p></div>
            <div class="CloseBox" @click="closeWindow"><img src="../assets/Home/exit1.png"></div>
            <div class="Content">
              <div class="flexa NowMoney"><span>当前余额</span><span>RMB</span><span>5,000</span></div>
              <div class="flexa Input"><span>充值金额</span><input /></div>
              <div class="Text">
                  <div>充值说明</div>
                  <ul>
                      <li>1. 说明1说明1说明1说明1说明1</li>
                      <li>2. 说明2</li>
                      <li>3. 说明3说明3说明3说明3</li>
                  </ul>
              </div>
              <div class="Text">
                    <div>当前套餐</div>
                    <ul>
                        <li>套餐名  到期时间</li>
                        <li>说明</li>
                    </ul>
                </div>
            </div>
            <div class="ButtonWrap flexa"><p>充值即代表您同意<span>《GOEASY充值协议》</span></p><div class="SubmitButton flex"><span>充值</span></div></div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'savemoney',
    inject: [
      'load'
    ],
    components: {},
    props: {},
    data () {
      return {
      };
    },
    mounted () {},
    methods: {
      OpenUrl(url) {
        window.open(url, '_blank');
      },
      closeWindow() {
        this.$emit('closeWindow');
      }
    }

  };
</script>
<style lang="scss" scoped>
    @import '../../public/Value';
    .SaveMoney {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 4;
        .Content{
            width: 90%;
            margin:0.12rem auto 0;
            .Text{
                width: 100%;
                margin-top: 0.08rem;
                border-bottom: 3px solid #fff;
                padding-bottom: 0.05rem;
                ul{
                    width: 100%;
                    li{
                        width: 100%;
                        margin-bottom: 0.06rem;
                        font-size: $AdditionTextSize;
                        color: #fff;
                        opacity: 0.8;
                    }
                }
                div{
                    font-size: $SmallTitleSize;
                    color: #fff;
                    font-weight: bold;
                    margin-bottom: 0.1rem;
                }
            }
            .Input{
                width: 100%;
                height: 0.3rem;
                margin-top: 0.05rem;
                input{
                    width: 1.2rem;
                    height: 0.13rem;
                    background-color: #fff;
                    border-radius: 0.15rem;
                    font-size: $TextSize;
                    text-indent: 0.05rem;
                }
                span{
                    font-size: $SmallTitleSize;
                    color: #fff;
                    font-weight: bold;
                    margin-right: 0.2rem;
                }
            }
            .NowMoney{
                width: 100%;
                height: 0.3rem;
                border-bottom: 3px solid #fff;
                span{
                    font-size: $SmallTitleSize;
                    color: #fff;
                    font-weight: bold;
                }
                span:first-child{
                    margin-top: 0.03rem;
                }
                span:nth-child(2){
                    font-size: $AdditionTextSize;
                    font-weight: normal;
                    margin-left: 0.2rem;
                    margin-top: 0.05rem;
                }
                span:last-child{
                    font-size: $NumTitleSize;
                    margin-left: 0.05rem;
                };
            }
        }
        .SaveMoneyContentWrap {
            width: 2.7rem;
            border-radius: 0.02rem 0.1rem 0.1rem 0.1rem;
            background: linear-gradient(to bottom right, #6666cc, #4141b3);
            position: relative;

            .CloseBox {
                width: 0.15rem;
                height: 0.15rem;
                position: absolute;
                cursor: pointer;
                right: 0.05rem;
                top: 0.05rem;
                z-index: 4;

                img {
                    width: 100%;
                }
            }
            .ButtonWrap{
             width: 90%;
             margin-left: 5%;
             padding-bottom: 0.15rem;
             margin-top: 0.15rem;
             position: relative;
             .SubmitButton {
                     position: absolute;
                     right: 0;
                     width: 0.5rem;
                     height: 0.15rem;
                     border-radius: 0.3rem;
                     background-color: #fff;
                     cursor: pointer;
                     box-shadow: 5px 5px 15px #47478c;
                     span {
                         font-size: $TextSize;
                         color: #4848b8;
                     }
                 }
             p {
                 font-size: $SmallTextSize;
                 color: #fff;
                 text-align: center;

                 span {
                     cursor: pointer;
                     font-weight: bold;
                     margin: 0 0.02rem;
                     color: #999900;
                 }
             }
}
                     .LoginTitle {
                         width: 100%;
                         margin-top: 0.05rem;

                         p {
                             font-size: $TextSize;
                             color: #fff;
                             text-indent: 0.05rem;
                         }
                     }
                 }
             }
</style>
